import { initial } from 'lodash-es';
export const getFilenameWithoutExtension = (filename) => initial(filename.trim().split('.')).join('.');
